module.exports = __webpack_public_path__ + "static/img/12.13577cf6.png";